import { Divider } from "@mui/material";

import Swipi from "./Swipi";
import ite from "../../assets/images/ite.webp";
import qlgd from "../../assets/images/qlgd.webp";
import trungtam_daotao from "../../assets/images/trungtam_daotao.webp";
import udcdsyte from "../../assets/images/udcdsyte.webp";
import giaoduc from "../../assets/images/giaoduc.webp";

export default function NewDetailBody() {
  return (
    <div className="w-full mt-10">
      <div className="container mx-auto p-3 flex flex-col gap-5 w-full lg:flex-row lg:gap-5">
        <div className="w-full flex flex-col gap-5 lg:w-9/12">
          <div>
            <p className="text-[32px] font-bold text-black">
              {" "}
              Giải pháp chuyển đổi số giáo dục
            </p>
          </div>
          <div>
            <p className="font-semibold">I. Giới thiệu</p>
          </div>
          <div className="w-full">
            <p>
              Chuyển đổi số trong giáo dục là xu hướng tất yếu trong thời đại
              công nghệ số hiện nay. Quá trình này không chỉ giới hạn ở việc
              thay đổi phương thức dạy và học mà còn bao gồm các yếu tố về quản
              lý và vận hành hệ thống giáo dục. Mục tiêu chính là sử dụng công
              nghệ hiện đại như trí tuệ nhân tạo (AI), điện toán đám mây
              (Cloud), dữ liệu lớn (Big Data), và nhiều công nghệ khác để nâng
              cao trải nghiệm học tập, đồng thời tối ưu hóa các quy trình quản
              lý trong nhà trường và các cơ sở đào tạo.
            </p>
          </div>
          <div className="w-full">
            <p className="font-semibold">
              II. Lợi ích của Chuyển đổi số trong Giáo dục  
            </p>
          </div>
          <div className="w-full flex flex-col gap-2">
            <p>
              1. Nâng cao tính linh hoạt và tiện lợi Chuyển đổi số mở ra khả
              năng học trực tuyến (e-learning), giúp học viên có thể tiếp thu
              kiến thức mọi lúc, mọi nơi. Học sinh có thể truy cập bài giảng,
              làm bài kiểm tra hoặc tham gia thảo luận mà không cần đến trường​.
              Điều này giúp tiết kiệm thời gian, giảm chi phí và tạo điều kiện
              cho người học ở các khu vực xa xôi có thể tiếp cận nền giáo dục
              chất lượng cao​.
            </p>
            <p>
              2. Cải thiện phương pháp giảng dạy và quản lý Công nghệ hỗ trợ
              chuyển đổi số không chỉ giúp cải thiện phương pháp giảng dạy mà
              còn tạo điều kiện cho sự tương tác đa chiều. Lớp học ảo với các
              công nghệ như thực tế ảo (VR) và thực tế tăng cường (AR) giúp bài
              giảng trở nên sinh động và thu hút học sinh hơn​.
            </p>
            <p>
              3. Thu hẹp khoảng cách địa lý Các nền tảng học tập số giúp người
              học ở vùng sâu, vùng xa hoặc người có nhu cầu đặc biệt dễ dàng
              tham gia các lớp học từ xa. Điều này không chỉ giúp thu hẹp khoảng
              cách địa lý mà còn mang lại môi trường học tập tiện lợi và dễ tiếp
              cận​.
            </p>
          </div>
          <div className="flex items-center justify-center">
            <img
              src={giaoduc}
              alt=""
              className="block md:hidden lg:hidden w-full h-auto"
            />
            <img
              src={giaoduc}
              alt=""
              className="hidden md:block lg:block w-full h-auto lg:w-[400px] lg:h-[300px]"
            />
          </div>
          <div>
            <p className="font-semibold">
              III. Các Giải pháp Chuyển đổi số trong Giáo dục
            </p>
            <p>
              1. Giải pháp về cơ sở hạ tầng Đầu tư vào mạng internet tốc độ cao
              và các thiết bị công nghệ hiện đại như máy tính, máy chiếu và các
              công cụ hỗ trợ khác là bước đầu tiên trong chuyển đổi số giáo dục.
              Các trường học cần đảm bảo cơ sở hạ tầng tốt để học sinh và giáo
              viên có thể tiếp cận công nghệ một cách dễ dàng​. Ứng dụng công
              nghệ trong giảng dạy
            </p>
          </div>
          <div>
            <p>
              2. Ứng dụng công nghệ trong giảng dạy Việc sử dụng e-learning,
              công nghệ VR (thực tế ảo), và AR (thực tế tăng cường) giúp bài
              giảng trở nên sinh động và hấp dẫn. Ví dụ, VR có thể mô phỏng các
              hiện tượng tự nhiên trong môn khoa học, giúp học sinh hiểu bài học
              nhanh chóng và sâu sắc hơn​.
            </p>
          </div>
          <div>
            <p>
              3. Hệ thống quản lý học tập (LMS) Các phần mềm quản lý học tập như
              Moodle, Canvas là những nền tảng LMS phổ biến, giúp giáo viên quản
              lý bài giảng, điểm số, và theo dõi tiến độ học tập của học sinh
              một cách dễ dàng. LMS cũng giúp học sinh và phụ huynh có thể tra
              cứu thông tin học tập của mình nhanh chóng​.
            </p>
          </div>
          <div>
            <p>
              4. Số hóa tài liệu giảng dạy Xây dựng thư viện số với các tài liệu
              học tập và sách giáo khoa là giải pháp cần thiết để học sinh và
              giáo viên có thể truy cập dễ dàng. Thư viện số giúp lưu trữ, chia
              sẻ tài liệu nhanh chóng và dễ dàng cập nhật nội dung.
            </p>
          </div>
          <div>
            <p className="font-semibold">
              IV. Thách thức của Chuyển đổi số trong Giáo dục
            </p>
          </div>
          <div>
            <p>
              1. Chi phí đầu tư cơ sở hạ tầng Đầu tư vào thiết bị công nghệ,
              mạng internet và các phần mềm hỗ trợ yêu cầu ngân sách lớn, điều
              mà không phải cơ sở giáo dục nào cũng có thể đáp ứng​.
            </p>
          </div>
          <div>
            <p>
              2. Đào tạo giáo viên về công nghệ Nhiều giáo viên chưa quen với
              công nghệ hoặc chưa được đào tạo để sử dụng các công cụ hỗ trợ
              giảng dạy hiện đại. Do đó, đào tạo và hỗ trợ giáo viên trong việc
              sử dụng công nghệ là một bước quan trọng trong chuyển đổi số.
            </p>
          </div>
          <div>
            <p>
              3. Khó khăn trong việc thay đổi tư duy giáo dục truyền thống
              Chuyển đổi số yêu cầu sự linh hoạt và thay đổi trong tư duy giáo
              dục. Một số giáo viên và phụ huynh lo ngại rằng việc học trực
              tuyến sẽ làm giảm chất lượng học tập của học sinh. Điều này đòi
              hỏi các trường học phải có chiến lược truyền thông và giải thích
              rõ ràng về lợi ích của chuyển đổi số​.
            </p>
          </div>
          <div>
            <p className="font-semibold">V. Câu hỏi thường gặp (FAQ)</p>
          </div>
          <div>
            <p>
              1. Tại sao chuyển đổi số trong giáo dục lại quan trọng? Chuyển đổi
              số giúp nâng cao chất lượng học tập, cải thiện phương pháp giảng
              dạy và quản lý, đồng thời tạo cơ hội tiếp cận giáo dục cho mọi đối
              tượng.
            </p>
          </div>
          <div>
            <p>
              2. Chuyển đổi số giúp nâng cao hiệu quả học tập và giảng dạy như
              thế nào? Công nghệ giúp bài giảng trở nên sinh động, dễ hiểu, hỗ
              trợ học sinh tiếp thu kiến thức nhanh chóng, đồng thời giúp giáo
              viên quản lý học sinh hiệu quả hơn.
            </p>
          </div>
          <div>
            <p>
              3. Các thách thức chính của chuyển đổi số trong giáo dục là gì?
              Thách thức bao gồm chi phí đầu tư cao, yêu cầu đào tạo giáo viên
              về công nghệ, và khó khăn trong việc thay đổi tư duy giáo dục
              truyền thống.
            </p>
          </div>
          <div>
            <p>
              4. Giải pháp chuyển đổi số nào là phổ biến nhất? E-learning, hệ
              thống quản lý học tập (LMS), và thư viện số là những giải pháp phổ
              biến giúp nâng cao chất lượng giảng dạy và quản lý học sinh hiệu
              quả.
            </p>
          </div>
          <div>
            <p className="font-semibold">VI. Kết luận</p>
          </div>
          <div>
            <p>
              Chuyển đổi số trong giáo dục không chỉ giúp cải thiện phương pháp
              giảng dạy và nâng cao chất lượng học tập mà còn là cơ hội để nền
              giáo dục Việt Nam tiếp cận với các công nghệ tiên tiến trên thế
              giới. Việc áp dụng thành công các giải pháp chuyển đổi số sẽ giúp
              học sinh, sinh viên có trải nghiệm học tập tốt hơn và tạo ra môi
              trường giáo dục phù hợp với nhu cầu của thế kỷ 21.
            </p>
          </div>
        </div>
        <div className="block md:hidden lg:hidden">
          <Divider />
        </div>

        <div className="w-full grid grid-cols-1 gap-4 lg:w-3/12 lg:h-[500px]">
          <div>
            <p className="text-[28px] text-[#033F6A] font-semibold">
              Tin liên quan
            </p>
          </div>
          <div className="w-full h-[160px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img src={ite} alt="" className="rounded-s-md h-[160px] w-full" />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <a href="/new-detail">
                  <p className="text-[14px] text-[#1F1F1F] font-semibold hover:text-blue-500 w-[198px]">
                    Giải Pháp Phần Mềm Y Tế: Ứng Dụng Công Nghệ trong Chăm Sóc
                    Sức Khỏe
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full h-[160px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={qlgd}
                alt=""
                className="rounded-s-md h-[160px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <a href="/new-detail">
                  <p className="text-[14px] text-[#1F1F1F]  hover:text-blue-500 font-semibold w-[198px]">
                    Giải Pháp Phần Mềm Quản Lý Giáo Dục: Tăng Hiệu Quả Và Nâng
                    Cao Chất Lượng Dạy Học
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full h-[160px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={trungtam_daotao}
                alt=""
                className="rounded-s-md h-[160px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <a href="/new-detail">
                  <p className="text-[14px] text-[#1F1F1F] hover:text-blue-500 font-semibold w-[198px]">
                    Phần Mềm Quản Trị Trung Tâm Đào Tạo: Tối Ưu Hóa Quản Lý Và
                    Nâng Cao Hiệu Suất
                  </p>
                </a>
              </div>
            </div>
          </div>
          <div className="w-full h-[160px] rounded-[6px] bg-white border border-solid border-gray-200 flex items-center gap-4 ">
            <div>
              <img
                src={udcdsyte}
                alt=""
                className="rounded-s-md h-[160px] w-full"
              />
            </div>
            <div className="flex flex-col gap-2">
              <div>
                <p className="text-[14px] text-[#919191] font-normal">
                  Tin tức
                </p>
              </div>
              <div>
                <a href="/new-detail">
                  <p className="text-[14px] text-[#1F1F1F] hover:text-blue-500 font-semibold w-[198px]">
                    Ứng Dụng Chuyển Đổi Số Trong Y Tế: Tăng Cường Chăm Sóc Sức
                    Khỏe Và Hiệu Quả Vận Hành
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto p-3">
        <div>
          <p className="text-[28px] text-[#033F6A] font-semibold">
            Bạn có thể quan tâm
          </p>
        </div>
        <div className="bg-[#F8FFFF]">
          <Swipi />
        </div>
      </div>
    </div>
  );
}
